/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class CalendarApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `CalendarModule.forRoot()`
 */
export interface CalendarApiConfigurationParams {
  rootUrl?: string;
}
